import { Routes } from '@angular/router';
import { AuthGuard } from '@rd/core/auth/guards/auth.guard';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { RewardsProgramsGuard } from './rewards-program/guards/rewards-programs-guard.service';
import { BnzHomePageComponent } from './static-pages/views/home-page/home-page.component';

export const routes: Routes = [
  {
    path: '',
    component: BnzHomePageComponent,
    canActivate: [RewardsProgramsGuard],
  },
  {
    path: 'auto_redemption_settings',
    loadComponent: () =>
      import(
        './bank-wide/auto-redemption-settings/auto-redemption-settings.component'
      ).then((m) => m.BnzAutoRedemptionSettingsComponent),
    canActivate: [AuthGuard, RewardsProgramsGuard],
  },
  {
    path: 'share_points',
    loadChildren: () =>
      import('./bank-wide/pool-points/pool-points.module').then(
        (m) => m.BnzPoolPointsModule,
      ),
    canActivate: [AuthGuard, RewardsProgramsGuard],
  },
  {
    path: 'points_activity',
    loadChildren: () =>
      import('./points-transaction/points-transaction-wrapper.module').then(
        (m) => m.PointsTransactionWrapperModule,
      ),
    canActivate: [RewardsProgramsGuard],
  },
  {
    path: 'redeem_cash',
    loadChildren: () =>
      import('./redeem-cash-v2/redeem-cash-v2-wrapper.module').then(
        (m) => m.RedeemCashWrapperModule,
      ),
    canActivate: [RewardsProgramsGuard],
  },
  {
    path: 'offers',
    loadChildren: () =>
      import('./offer/offer-wrapper.module').then((m) => m.OfferWrapperModule),
    canActivate: [RewardsProgramsGuard],
  },
  {
    path: 'gift_card',
    loadChildren: () =>
      import('./gift-card/gift-card.module').then((m) => m.GiftCardModule),
    canActivate: [RewardsProgramsGuard],
  },
  {
    path: 'transfer',
    loadChildren: () =>
      import('./transfer-connect-v2/transfer-connect-v2-wrapper.module').then(
        (m) => m.TransferConnectV2WrapperModule,
      ),
    canActivate: [RewardsProgramsGuard],
  },
  {
    path: '',
    loadChildren: () =>
      import('./static-pages/static-pages.module').then(
        (m) => m.BnzStaticPagesModule,
      ),
    canActivate: [RewardsProgramsGuard],
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];
